function generateGuidQuickly() {
  return Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
}

export { generateGuidQuickly as g };

//# sourceMappingURL=generateGuid-6da97900.js.map